<template>
  <div class="page">
    <!-- 我的奖品：按设计稿定位在主视觉右上 -->
    <img
      class="my-prize"
      :src="myPrizeIcon"
      alt="我的奖品"
      @click="goMyPrize"
    />

    <p class="greet">
      亲爱的<span>{{ userName }}</span>，请领取您的奖励
    </p>

    <div class="award-list">
      <div
        v-for="item in awardList"
        :key="item.id || item.level"
        class="award-card"
        :style="{ backgroundImage: `url(${cardBg})` }"
      >
        <img v-if="item.badge" class="badge" :src="item.badge" alt="" />

        <div class="award-body">
          <img class="prize-img" :src="item.prizeImg" alt="" />
          <div class="award-right">
            <div class="name">{{ item.prizeName }}</div>
            <p class="rule">
              <span class="label">领取规则：</span>
              <span class="text">{{ item.rule }}</span>
            </p>
            <div
              class="award-btn"
              :style="{
                backgroundImage: `url(${getBtnBg(item.receiveStatus)})`
              }"
              @click="onAwardClick(item)"
            >
              {{ getBtnText(item.receiveStatus) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <select-prize
      :visible="selectVisible"
      :receive-id="currentReceive.id"
      :goods-list="currentReceive.goodsList"
      @close="selectVisible = false"
      @success="onSelectSuccess"
    />
  </div>
</template>

<script>
import { getToken, getUserInfo, getActivityPrizeInfo } from '@/api/erkeAiStore'
import SelectPrize from './selectPrize.vue'

// 本地仅补 level 对应配图（后端无图字段）
const levelAssets = {
  1: {
    badge: require('@/assets/img/erkeAiStore/award-badge-01.png'),
    prizeImg: require('@/assets/img/erkeAiStore/award-prize-01.png')
  },
  2: {
    badge: require('@/assets/img/erkeAiStore/award-badge-02.png'),
    prizeImg: require('@/assets/img/erkeAiStore/award-prize-02.png')
  },
  3: {
    badge: require('@/assets/img/erkeAiStore/award-badge-03.png'),
    prizeImg: require('@/assets/img/erkeAiStore/award-prize-03.png')
  }
}

const btnClaim = require('@/assets/img/erkeAiStore/award-btn-claim.png')
const btnClaimed = require('@/assets/img/erkeAiStore/award-btn-claimed.png')
const btnDisabled = require('@/assets/img/erkeAiStore/award-btn-disabled.png')

export default {
  name: 'ErkeAiStoreAward',
  components: { SelectPrize },
  data() {
    return {
      cardBg: require('@/assets/img/erkeAiStore/award-card-bg.png'),
      myPrizeIcon: require('@/assets/img/erkeAiStore/award-my-prize.png'),
      userName: '用户',
      awardList: [],
      selectVisible: false,
      currentReceive: {
        id: '',
        goodsList: []
      }
    }
  },
  created() {
    if (!getToken()) {
      this.$router.replace({ name: 'erkeAiStoreLogin' })
      return
    }
    this.initPage()
  },
  methods: {
    // receiveStatus: 0待领取 1已领取 2领取失败 3领取中, null 未达标
    getBtnText(receiveStatus) {
      if (receiveStatus === 0) return '立即领取'
      if ([1, 2, 3].includes(receiveStatus)) return '已领取去查看'
      return '暂未达标'
    },
    getBtnBg(receiveStatus) {
      if (receiveStatus === 0) return btnClaim
      if ([1, 2, 3].includes(receiveStatus)) return btnClaimed
      return btnDisabled
    },
    async initPage() {
      await Promise.all([this.fetchUserInfo(), this.fetchPrizeInfo()])
    },
    async fetchUserInfo() {
      const { code, data } = await getUserInfo()
      if (code === 0 && data?.userName) {
        this.userName = data.userName
      }
    },
    async fetchPrizeInfo() {
      try {
        const { code, data } = await getActivityPrizeInfo()
        if (code === 0) {
          this.awardList = (Array.isArray(data) ? data : []).map(item => {
            const assets = levelAssets[item.level] || {}
            return {
              ...item,
              badge: assets.badge,
              prizeImg: assets.prizeImg
            }
          })
        } else {
          this.awardList = []
        }
      } catch (e) {
        this.awardList = []
      }
    },
    goMyPrize() {
      this.$router.push({ name: 'erkeAiStoreMyPrize' })
    },
    onAwardClick(item) {
      // receiveStatus: 0待领取 1已领取 2领取失败 3领取中, null 未达标
      if (item.receiveStatus === 0) {
        this.currentReceive = {
          id: item.id,
          goodsList: item.goodsList || []
        }
        this.selectVisible = true
      } else if ([1, 2, 3].includes(item.receiveStatus)) {
        this.$router.push({
          name: 'erkeAiStoreMyPrize',
          query: { id: item.id }
        })
      } else {
        this.$toast('暂未达标，再接再厉')
      }
    },
    onSelectSuccess() {
      this.selectVisible = false
      this.$router.push({ name: 'erkeAiStoreMyPrize' })
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  position: relative;
  min-height: 100vh;
  background: #e93708 url('~@/assets/img/erkeAiStore/award-hero.png') top center
    no-repeat;
  background-size: 100% auto;
  padding: 0 6px 24px;
  box-sizing: border-box;
}

.my-prize {
  position: absolute;
  top: 27px;
  right: 0;
  width: 114px;
  height: auto;
  z-index: 2;
}

.greet {
  margin: 0 0 10px;
  padding-top: 270px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  line-height: 14px;

  span {
    font-weight: 700;
  }
}

.award-list {
  .award-card {
    position: relative;
    width: 100%;
    min-height: 194px;
    margin-bottom: 6px;
    padding: 13px 16px 0px 20px;
    box-sizing: border-box;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;

    .badge {
      position: absolute;
      top: 25px;
      left: 25px;
      width: 30px;
      height: auto;
    }

    .award-body {
      display: flex;
      align-items: center;

      .prize-img {
        width: 90px;
        height: 90px;
        flex-shrink: 0;
        object-fit: contain;
      }

      .award-right {
        flex: 1;
        margin:0 10px;
        min-width: 0;

        .name {
          font-size: 18px;
          font-weight: 600;
          color: #1a0c09;
          line-height: 18px;
          margin-bottom: 15px;
        }

        .rule {
          margin: 0 0 10px;
          font-size: 12px;
          line-height: 16px;

          .label {
            color: #000;
            font-weight: 600;
          }

          .text {
            color: #646464;
          }
        }

        .award-btn {
          width: 157px;
          height: 50px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          font-size: 15px;
          font-weight: 600;
          color: #fff;
          line-height: 50px;
          text-align: center;
          padding-right: 20px;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
